var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2 flex flex-row items-center"},[_c('img',{attrs:{"src":require("./../../assets/svg/error.svg")}}),_c('span',{staticClass:"font-light text-xs text-secondaryRed ml-2"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }